import { ValueNode } from './value-node.js';
import { traceGraphWarning } from '../debug.js';
/**
 * Value Get for a graph/local variable. Const gets are foldable leaves.
 */
export class GetVariableNode extends ValueNode {
    store;
    variableId;
    unsubscribe = null;
    constructor(id, data, type, store) {
        super(id, data, type, undefined, false);
        this.store = store;
        this.variableId = typeof data.variableId === 'string' ? data.variableId : '';
        if (!this.variableId) {
            traceGraphWarning(`getVariable (${id}) has no variable binding - reads undefined`, { variableId: data.variableId });
        }
        if (store && this.variableId) {
            this.unsubscribe = store.subscribe((changedId) => {
                if (changedId !== this.variableId)
                    return;
                if (store.isConst(this.variableId))
                    return;
                this.forceDirty();
            });
        }
    }
    /** Const/fold path may lock the node; mutable updates must still invalidate. */
    forceDirty() {
        this.clearFolded();
        this.markDirty();
    }
    getOutPortData(outPortKey) {
        if (outPortKey !== 'value')
            return super.getOutPortData(outPortKey);
        if (this.isFolded())
            return super.getOutPortData(outPortKey);
        const value = this.store?.get(this.variableId);
        this.data.value = value;
        return value;
    }
    evaluateAll() {
        const value = this.store?.get(this.variableId);
        this.data.value = value;
        return { value };
    }
    dispose() {
        this.unsubscribe?.();
        this.unsubscribe = null;
    }
}
